module.exports = __webpack_public_path__ + "static/experience_scene4-fba1ed717273e15021150ee8cff37dd0.svg";